function removeSticky(scrollStickyElement, oldTop) {
  scrollStickyElement.classList.remove('topSticky');
  scrollStickyElement.classList.remove('bottomSticky');
  scrollStickyElement.style.top = `${oldTop}px`;
  scrollStickyElement.style.position = '';
  scrollStickyElement.style.bottom = '';
}

function setTopSticky(scrollStickyElement, offsetHeader) {
  scrollStickyElement.classList.add('topSticky');
  scrollStickyElement.style.position = 'sticky';
  scrollStickyElement.style.top = `${offsetHeader}px`;
}

function setBottomSticky(scrollStickyElement) {
  scrollStickyElement.classList.add('bottomSticky');
  scrollStickyElement.style.position = 'fixed';
  scrollStickyElement.style.bottom = '0';
  scrollStickyElement.style.top = '';
}

function scrollSticky(offsetHeader = 40 + 30) {
  let oldTop = 0;
  let oldScrollPosition = 0;
  return (e) => {
    const scrollDirectionDown = window.scrollY - oldScrollPosition > 0;
    oldScrollPosition = window.scrollY;

    /** @type {HTMLElement} */
    const scrollStickyElement = document.querySelector('.scroll-sticky');
    const container = scrollStickyElement.parentElement;
    const containerRect = container.getBoundingClientRect();
    const rect = scrollStickyElement.getBoundingClientRect();

    // check if scrollSticky is smaller than viewport
    if (scrollStickyElement.clientHeight < (window.innerHeight - offsetHeader)) {
      removeSticky(scrollStickyElement, oldTop);
      setTopSticky(scrollStickyElement, offsetHeader);
      return;
    }

    // 🔝 check top
    if (!scrollDirectionDown) {
      if (rect.top.toFixed() > offsetHeader && !scrollStickyElement.classList.contains('topSticky')) {
        setTopSticky(scrollStickyElement, offsetHeader);
      }
    }
    if (scrollStickyElement.classList.contains('topSticky')) {
      // scrolling up detected
      if (scrollDirectionDown) {
        // use old top value to set it as top and remove bottomSticky
        removeSticky(scrollStickyElement, oldTop);
      }
    }

    // ⏬ check bottom
    if (rect.bottom.toFixed() < window.innerHeight) {
      setBottomSticky(scrollStickyElement);
    }

    if (scrollStickyElement.classList.contains('bottomSticky')) {
      // scrolling up detected
      if (!scrollDirectionDown) {
        // use old top value to set it as top and remove bottomSticky
        removeSticky(scrollStickyElement, oldTop);
      }
    }
    const a = 0 - containerRect.top; // needs to be positive to calculate the correct distance
    const b = 0 - rect.top; // needs to be positive to calculate the correct distance
    oldTop = a - b;
  };
}

export function addScrollStickyListener(offsetHeader) {
  window.addEventListener('scroll', scrollSticky(offsetHeader));
  window.addEventListener('resize', scrollSticky(offsetHeader));
}

export function removeScrollStickyListener(offsetHeader) {
  window.removeEventListener('scroll', scrollSticky(offsetHeader));
  window.removeEventListener('resize', scrollSticky(offsetHeader));
}
